import useApiMutation from 'shared/hooks/use-api-mutation';
import useInfiniteQueryHelpers from 'shared/hooks/use-infinite-query-helpers';
import {CompanyProps} from '../types';
import companiesKeys from '../util/companies-keys';

export interface CreateCompanyProps {
  name: string;
}

const useCreateCompany = () => {
  const {create} = useInfiniteQueryHelpers();

  const onSuccess = (data: CompanyProps) => create(companiesKeys.list(), data);

  return useApiMutation<CreateCompanyProps>({
    url: '/companies',
    method: 'POST',
    errorTitle: 'Erro ao cadastrar empresa',
    successTitle: 'Cadastrar empresa',
    successMessage: 'Empresa cadastrada com sucesso',
    redirectUrl: (data) => `/settings/companies/${data.id}`,
    onSuccess,
  });
};

export default useCreateCompany;
